import React, { useState } from 'react';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { FileUploader } from '@cokitchen/cokitchen-components';
import { STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onRefetch: () => void;
};
const AddPlainDesign = ({ isOpen, onClose, onRefetch }: Props) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;

  const resetFileUploader = () => {
    setImageUrl('');
  };

  const uploadPlainDesign = async () => {
    const payload = {
      image_url: imageUrl
    };
    setLoading(true);
    try {
      await apiService.post(`vouchers/plain-cards`, {
        data: payload,
        isInternal: true,
        baseURL: process.env.REACT_APP_ORDER_API
      });
      toast(<ToastMessage type='success' message='Changes has been saved' />);
      await onRefetch();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
      onClose();
      resetFileUploader();
    }
  };
  return (
    <BaseModal
      isOpen={isOpen}
      title='Add Plain Design'
      onRequestClose={() => {
        onClose();
        resetFileUploader();
      }}>
      <div>
        <FileUploader
          label={<p className='mb-3'>Upload Image</p>}
          token={token}
          setFileUrls={(urls) => {
            setImageUrl(urls[0]);
          }}
          fileUrls={imageUrl ? [imageUrl] : []}
        />

        <Button
          className='w-[370px] h-[30px] mt-10 ml-10'
          variant='block'
          onClick={uploadPlainDesign}
          color='primary'
          loading={loading}
          disabled={!imageUrl}>
          Save image
        </Button>
      </div>
    </BaseModal>
  );
};

export default AddPlainDesign;
